import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _41d4c37a = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _64d185ab = () => interopDefault(import('..\\pages\\articles\\index.vue' /* webpackChunkName: "pages/articles/index" */))
const _72e5d572 = () => interopDefault(import('..\\pages\\aup.vue' /* webpackChunkName: "pages/aup" */))
const _fcab7392 = () => interopDefault(import('..\\pages\\careers\\index.vue' /* webpackChunkName: "pages/careers/index" */))
const _72a3edd6 = () => interopDefault(import('..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _2804fed5 = () => interopDefault(import('..\\pages\\disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _7889ac26 = () => interopDefault(import('..\\pages\\docs\\index.vue' /* webpackChunkName: "pages/docs/index" */))
const _02650df0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _617b8a26 = () => interopDefault(import('..\\pages\\game-design-tool.vue' /* webpackChunkName: "pages/game-design-tool" */))
const _6ba6f377 = () => interopDefault(import('..\\pages\\games.vue' /* webpackChunkName: "pages/games" */))
const _0bc6072a = () => interopDefault(import('..\\pages\\glossary\\index.vue' /* webpackChunkName: "pages/glossary/index" */))
const _f37efc70 = () => interopDefault(import('..\\pages\\learn\\index.vue' /* webpackChunkName: "pages/learn/index" */))
const _ee81c6b8 = () => interopDefault(import('..\\pages\\liveops-whitepaper.vue' /* webpackChunkName: "pages/liveops-whitepaper" */))
const _40126a7d = () => interopDefault(import('..\\pages\\partners\\index.vue' /* webpackChunkName: "pages/partners/index" */))
const _b0cbaaf4 = () => interopDefault(import('..\\pages\\pricing\\index.vue' /* webpackChunkName: "pages/pricing/index" */))
const _380c7a0b = () => interopDefault(import('..\\pages\\search-results.vue' /* webpackChunkName: "pages/search-results" */))
const _88a3ddd8 = () => interopDefault(import('..\\pages\\terms-and-conditions\\index.vue' /* webpackChunkName: "pages/terms-and-conditions/index" */))
const _69607d04 = () => interopDefault(import('..\\pages\\community\\explore.vue' /* webpackChunkName: "pages/community/explore" */))
const _e2bb3cd0 = () => interopDefault(import('..\\pages\\community\\see-all.vue' /* webpackChunkName: "pages/community/see-all" */))
const _5f68ed1d = () => interopDefault(import('..\\pages\\docs\\search.vue' /* webpackChunkName: "pages/docs/search" */))
const _6e4f524e = () => interopDefault(import('..\\pages\\resources\\academic-research-publications.vue' /* webpackChunkName: "pages/resources/academic-research-publications" */))
const _271f2d7f = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\index.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/index" */))
const _4556b21f = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\index.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/index" */))
const _6a67f9fe = () => interopDefault(import('..\\pages\\articles\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/page/_pageNumber" */))
const _146a402b = () => interopDefault(import('..\\pages\\careers\\job\\_jobSlug.vue' /* webpackChunkName: "pages/careers/job/_jobSlug" */))
const _7f588cd5 = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/page/_pageNumber" */))
const _b763bd16 = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/page/_pageNumber" */))
const _2f98b3a3 = () => interopDefault(import('..\\pages\\articles\\_slugPost.vue' /* webpackChunkName: "pages/articles/_slugPost" */))
const _73d904f9 = () => interopDefault(import('..\\pages\\docs\\_docSlug.vue' /* webpackChunkName: "pages/docs/_docSlug" */))
const _0a0f65e2 = () => interopDefault(import('..\\pages\\glossary\\_slug.vue' /* webpackChunkName: "pages/glossary/_slug" */))
const _4531db8a = () => interopDefault(import('..\\pages\\learn\\_learnSlug.vue' /* webpackChunkName: "pages/learn/_learnSlug" */))
const _0ff75f36 = () => interopDefault(import('..\\pages\\community\\_communityUser\\profile.vue' /* webpackChunkName: "pages/community/_communityUser/profile" */))
const _469b0e88 = () => interopDefault(import('..\\pages\\community\\_communityUser\\_userAction.vue' /* webpackChunkName: "pages/community/_communityUser/_userAction" */))
const _05d25080 = () => interopDefault(import('..\\pages\\_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _41d4c37a,
    pathToRegexpOptions: {"strict":true},
    name: "about___en___default"
  }, {
    path: "/articles",
    component: _64d185ab,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en___default"
  }, {
    path: "/aup",
    component: _72e5d572,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en___default"
  }, {
    path: "/careers",
    component: _fcab7392,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en___default"
  }, {
    path: "/contact",
    component: _72a3edd6,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en___default"
  }, {
    path: "/disclaimer",
    component: _2804fed5,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en___default"
  }, {
    path: "/docs",
    component: _7889ac26,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en___default"
  }, {
    path: "/en",
    component: _02650df0,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/game-design-tool",
    component: _617b8a26,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en___default"
  }, {
    path: "/games",
    component: _6ba6f377,
    pathToRegexpOptions: {"strict":true},
    name: "games___en___default"
  }, {
    path: "/glossary",
    component: _0bc6072a,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en___default"
  }, {
    path: "/learn",
    component: _f37efc70,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en___default"
  }, {
    path: "/liveops-whitepaper",
    component: _ee81c6b8,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en___default"
  }, {
    path: "/partners",
    component: _40126a7d,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en___default"
  }, {
    path: "/pricing",
    component: _b0cbaaf4,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en___default"
  }, {
    path: "/search-results",
    component: _380c7a0b,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en___default"
  }, {
    path: "/terms-and-conditions",
    component: _88a3ddd8,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en___default"
  }, {
    path: "/community/explore",
    component: _69607d04,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en___default"
  }, {
    path: "/community/see-all",
    component: _e2bb3cd0,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en___default"
  }, {
    path: "/docs/search",
    component: _5f68ed1d,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en___default"
  }, {
    path: "/en/about",
    component: _41d4c37a,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/articles",
    component: _64d185ab,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/aup",
    component: _72e5d572,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en"
  }, {
    path: "/en/careers",
    component: _fcab7392,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/en/contact",
    component: _72a3edd6,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/en/disclaimer",
    component: _2804fed5,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en"
  }, {
    path: "/en/docs",
    component: _7889ac26,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en"
  }, {
    path: "/en/game-design-tool",
    component: _617b8a26,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en"
  }, {
    path: "/en/games",
    component: _6ba6f377,
    pathToRegexpOptions: {"strict":true},
    name: "games___en"
  }, {
    path: "/en/glossary",
    component: _0bc6072a,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en"
  }, {
    path: "/en/learn",
    component: _f37efc70,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en"
  }, {
    path: "/en/liveops-whitepaper",
    component: _ee81c6b8,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en"
  }, {
    path: "/en/partners",
    component: _40126a7d,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/en/pricing",
    component: _b0cbaaf4,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en"
  }, {
    path: "/en/search-results",
    component: _380c7a0b,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en"
  }, {
    path: "/en/terms-and-conditions",
    component: _88a3ddd8,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en"
  }, {
    path: "/resources/academic-research-publications",
    component: _6e4f524e,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en___default"
  }, {
    path: "/en/community/explore",
    component: _69607d04,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en"
  }, {
    path: "/en/community/see-all",
    component: _e2bb3cd0,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en"
  }, {
    path: "/en/docs/search",
    component: _5f68ed1d,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en"
  }, {
    path: "/en/resources/academic-research-publications",
    component: _6e4f524e,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en"
  }, {
    path: "/en/articles/author/:slugAuthor",
    component: _271f2d7f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en"
  }, {
    path: "/en/articles/category/:slugCategory",
    component: _4556b21f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en"
  }, {
    path: "/en/articles/page/:pageNumber?",
    component: _6a67f9fe,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en"
  }, {
    path: "/en/careers/job/:jobSlug?",
    component: _146a402b,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en"
  }, {
    path: "/en/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _7f588cd5,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en"
  }, {
    path: "/en/articles/category/:slugCategory?/page/:pageNumber?",
    component: _b763bd16,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en"
  }, {
    path: "/articles/author/:slugAuthor",
    component: _271f2d7f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en___default"
  }, {
    path: "/articles/category/:slugCategory",
    component: _4556b21f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en___default"
  }, {
    path: "/articles/page/:pageNumber?",
    component: _6a67f9fe,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en___default"
  }, {
    path: "/careers/job/:jobSlug?",
    component: _146a402b,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en___default"
  }, {
    path: "/en/articles/:slugPost",
    component: _2f98b3a3,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en"
  }, {
    path: "/en/docs/:docSlug",
    component: _73d904f9,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en"
  }, {
    path: "/en/glossary/:slug",
    component: _0a0f65e2,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en"
  }, {
    path: "/en/learn/:learnSlug",
    component: _4531db8a,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en"
  }, {
    path: "/en/community/:communityUser?/profile",
    component: _0ff75f36,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en"
  }, {
    path: "/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _7f588cd5,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en___default"
  }, {
    path: "/articles/category/:slugCategory?/page/:pageNumber?",
    component: _b763bd16,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en___default"
  }, {
    path: "/en/community/:communityUser?/:userAction?",
    component: _469b0e88,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en"
  }, {
    path: "/articles/:slugPost",
    component: _2f98b3a3,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en___default"
  }, {
    path: "/docs/:docSlug",
    component: _73d904f9,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en___default"
  }, {
    path: "/en/:slug",
    component: _05d25080,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en"
  }, {
    path: "/glossary/:slug",
    component: _0a0f65e2,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en___default"
  }, {
    path: "/learn/:learnSlug",
    component: _4531db8a,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en___default"
  }, {
    path: "/community/:communityUser?/profile",
    component: _0ff75f36,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en___default"
  }, {
    path: "/community/:communityUser?/:userAction?",
    component: _469b0e88,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en___default"
  }, {
    path: "/",
    component: _02650df0,
    pathToRegexpOptions: {"strict":true},
    name: "index___en___default"
  }, {
    path: "/:slug",
    component: _05d25080,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
